module.exports = __webpack_public_path__ + "img/viewresult.79b7b417.svg";